import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { User } from '../models/user.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class UserService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getUsers()
   {
     return this._http.get(this.url+'users/'+this.user_id).map(res => res.json());

   }

   getUser()
   {
     return "getCuser from service";
   }

   addUser(user: User)
   {
     let json = JSON.stringify(user);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-user/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateUser(id:number,pUser: User)
   {
     let json = JSON.stringify(pUser);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-user/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteUser(id:number)
   {
     return this._http.get(this.url+'delete-user/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/user.service.ts